import { lazy } from 'react';

export const lazyNamed = (importFn, name) =>
  lazy(() => importFn().then((m) => ({ default: m[name] ?? m.default })));

export const AudioPlayerWaveform = lazyNamed(
  () => import('../components/Music/AudioPlayerWaveform'),
  'AudioPlayerWaveform'
);
export const CookieBanner = lazyNamed(() => import('../components/Common/CookieBanner'), 'CookieBanner');
export const NotFound = lazyNamed(() => import('../components/NotFound'), 'NotFound');

export const HomePage = lazyNamed(() => import('../components/Pages/HomePage'), 'HomePage');
export const RootEntryPage = lazyNamed(
  () => import('../components/Pages/RootEntryPage'),
  'RootEntryPage'
);
export const LandingPage = lazyNamed(() => import('../components/Pages/LandingPage'), 'LandingPage');
export const ShopPage = lazyNamed(() => import('../components/Pages/ShopPage'), 'ShopPage');
export const DiscoverPage = lazyNamed(() => import('../components/Pages/DiscoverPage'), 'DiscoverPage');
export const SearchResultsPage = lazyNamed(
  () => import('../components/Pages/SearchResultsPage'),
  'SearchResultsPage'
);
export const LibraryPage = lazyNamed(() => import('../components/Pages/LibraryPage'), 'LibraryPage');
export const AlbumDetailPage = lazyNamed(() => import('../components/Pages/AlbumDetailPage'), 'AlbumDetailPage');
export const TrackDetailPage = lazyNamed(() => import('../components/Pages/TrackDetailPage'), 'TrackDetailPage');
export const UserProfilePage = lazyNamed(() => import('../components/Pages/UserProfilePage'), 'UserProfilePage');
export const PublicArtistProfile = lazyNamed(
  () => import('../components/Profile/PublicArtistProfile'),
  'PublicArtistProfile'
);
export const PublicUserProfile = lazyNamed(
  () => import('../components/Profile/PublicUserProfile'),
  'PublicUserProfile'
);
export const ResetPasswordPage = lazyNamed(() => import('../pages/ResetPasswordPage'), 'ResetPasswordPage');
export const PlansPage = lazyNamed(() => import('../components/Pages/PlansPage'), 'PlansPage');
export const CancelSubscriptionPage = lazyNamed(
  () => import('../components/Pages/CancelSubscriptionPage'),
  'CancelSubscriptionPage'
);
export const PlaylistDetail = lazyNamed(() => import('../components/Playlists/PlaylistDetail'), 'PlaylistDetail');
export const PurchasedPage = lazyNamed(() => import('../components/Purchased/PurchasedPage'), 'PurchasedPage');
export const AuthPage = lazyNamed(() => import('../pages/AuthPage'), 'AuthPage');
export const CreatorOnboarding = lazyNamed(
  () => import('../components/Onboarding/CreatorOnboarding'),
  'CreatorOnboarding'
);
export const VerifyEmailPage = lazyNamed(() => import('../pages/VerifyEmailPage'), 'VerifyEmailPage');
export const ConfirmDeleteAccountPage = lazyNamed(
  () => import('../pages/ConfirmDeleteAccountPage'),
  'ConfirmDeleteAccountPage'
);
export const ConfirmUsernameChangePage = lazyNamed(
  () => import('../pages/ConfirmUsernameChangePage'),
  'ConfirmUsernameChangePage'
);
export const ConfirmEmailChangePage = lazyNamed(
  () => import('../pages/ConfirmEmailChangePage'),
  'ConfirmEmailChangePage'
);
export const ConfirmSubscriptionCancelPage = lazyNamed(
  () => import('../pages/ConfirmSubscriptionCancelPage'),
  'ConfirmSubscriptionCancelPage'
);
export const MaintenancePage = lazyNamed(() => import('../components/Pages/MaintenancePage'), 'MaintenancePage');
export const CookiePolicy = lazyNamed(() => import('../pages/CookiePolicy'), 'CookiePolicy');
export const TermsOfService = lazyNamed(() => import('../pages/TermsOfService'), 'TermsOfService');
export const PrivacyPolicy = lazyNamed(() => import('../pages/PrivacyPolicy'), 'PrivacyPolicy');
export const ShoppingCart = lazyNamed(() => import('../components/Shop/ShoppingCart'), 'ShoppingCart');
export const Checkout = lazyNamed(() => import('../components/Shop/Checkout'), 'Checkout');
export const PaymentSuccess = lazyNamed(() => import('../components/Payment/PaymentSuccess'), 'PaymentSuccess');
export const PaymentCancel = lazyNamed(() => import('../components/Payment/PaymentCancel'), 'PaymentCancel');
export const DownloadByTokenPage = lazyNamed(
  () => import('../pages/DownloadByTokenPage'),
  'DownloadByTokenPage'
);
export const StripeConnectRefreshPage = lazyNamed(
  () => import('../components/Dashboard/Settings/StripeConnectRefreshPage'),
  'StripeConnectRefreshPage'
);

export const DashboardOverview = lazyNamed(
  () => import('../components/Dashboard/DashboardOverview'),
  'DashboardOverview'
);
export const ContentDashboard = lazyNamed(
  () => import('../components/Dashboard/ContentManagement/ContentDashboard'),
  'ContentDashboard'
);
export const AudiencePage = lazyNamed(
  () => import('../components/Dashboard/Audience/AudiencePage'),
  'AudiencePage'
);
export const ArtistProfilePage = lazyNamed(
  () => import('../components/Dashboard/Profile/ArtistProfilePage'),
  'ArtistProfilePage'
);
export const PublishWizard = lazyNamed(
  () => import('../components/Dashboard/Publish/PublishWizard'),
  'PublishWizard'
);
export const SettingsPage = lazyNamed(() => import('../components/Dashboard/Settings/SettingsPage'), 'SettingsPage');
export const AnalyticsOverview = lazyNamed(
  () => import('../components/Dashboard/Analytics/AnalyticsOverview'),
  'AnalyticsOverview'
);
export const PlaylistsPage = lazyNamed(
  () => import('../components/Dashboard/Playlists/PlaylistsPage'),
  'PlaylistsPage'
);
export const PlaylistEditPage = lazyNamed(
  () => import('../components/Playlists/PlaylistEditPage'),
  'PlaylistEditPage'
);
export const AlbumDetailDashboard = lazyNamed(
  () => import('../components/Dashboard/ContentManagement/AlbumDetailDashboard'),
  'AlbumDetailDashboard'
);
export const TrackDetailDashboard = lazyNamed(
  () => import('../components/Dashboard/ContentManagement/TrackDetailDashboard'),
  'TrackDetailDashboard'
);
export const UnifiedTrackManager = lazyNamed(
  () => import('../components/Upload/UnifiedTrackManager'),
  'UnifiedTrackManager'
);
export const AlbumForm = lazyNamed(() => import('../components/Artist/AlbumForm'), 'AlbumForm');
